/**
 * List of files that are not imported by a dependency directly. So we have to import them manual.
 */

import '@shopgate/tracking-core/core/Core';
import '@shopgate/tracking-core/plugins/trackers/FbPixel';
import '@shopgate/tracking-core/plugins/trackers/GaBase';
import '@shopgate/tracking-shopgate-analytics';



// WEBPACK FOOTER //
// ./Library/1.0/common/tracking/webFiles.js